import React from 'react';
import './styles.css';

export const PulseSpinner = ({ className }: { className?: string }) => {
  return <div className={`spinner ${className}`}></div>;
};
